import styled from 'styled-components';

export const List = styled.ol`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ListItem = styled.li``;

export const Separator = styled.div`
  align-self: center;
  color: var(--coolGray-300);
  line-height: 0;
`;
